import React from 'react'
import { convertTimetoString, stripDateString } from '../helperFunction';
import css from '../css/overview-event.module.css'; 


const Events = (props:any) => {
  const date = props.date?
  stripDateString(convertTimetoString(props.date,0)):
  stripDateString(convertTimetoString(new Date(),0));
  const time = props.date?
  convertTimetoString(props.date, 2):
  convertTimetoString(new Date(), 2);
  const name = props.name;
  const index = props.index;
  return (
    <div className={css.container}>
      <div>{date}</div>
      <div style={(index + 1) % 2 != 0 ? {borderLeft:'2px solid var(--text-green)'} : {borderLeft:'2px solid #1EBD74'}}>
        <span title={name} style={{
          display:'inline-block',
          wordBreak:"keep-all",
          wordWrap:'normal',
          overflow:'hidden',
          textOverflow:"ellipsis",
        }}>{name.length > 16 ? `${name.slice(0,12)}...`:name}</span>
        <span>{time}</span>
      </div>
    </div>
  )
}

export default Events
